var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return (_vm.owners_association)?_c('VotationDetail',{attrs:{"owners_association":_vm.owners_association,"votation":_vm.votation,"img-no":_vm.imgNo,"is-loading":_vm.isLoading,"no_votation":_vm.no_votation}}):_vm._e()}
var staticRenderFns = []

export { render, staticRenderFns }